function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Box, Button, Flex, Icon, icons } from '@tapresearch/ui/components';
import { Buttons } from 'Shared/Button';
import Link from '../../../common/Link';
export var ActionButtons = function(param) {
    var projectIdentifier = param.projectIdentifier;
    return /*#__PURE__*/ React.createElement(Box, {
        mb: {
            base: 4,
            sm: 0
        }
    }, /*#__PURE__*/ React.createElement(Flex, {
        justify: "flex-end"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/insights_platform/projects/".concat(projectIdentifier, "/data_export"),
        external: true
    }, /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread({}, Buttons.PrimarySmall), {
        mr: 4,
        rightIcon: /*#__PURE__*/ React.createElement(Icon, {
            icon: icons.fi.Download
        })
    }), "Download"))));
};
